export default "__VITE_ASSET__COqs9NFS__ 180w";